import {getApiUrl, getLiveKey, getToken} from "../utils/util-functions";

interface InvoiceCardFeeRecoverySummary {
    subtotal: string
    tax: string
    total: string
    discount: string
    surcharge: string
    amount_unpaid: string
}

export interface InvoiceCardFeeRecoverySummaryResponse {
    default: InvoiceCardFeeRecoverySummary;
    cfr: InvoiceCardFeeRecoverySummary;
}

export const getPreviewInvoiceCardFeeRecoverySummaryRequest = async (selectedOptionId: number, selectedAddOnOptionsIds: number[], signal?: AbortSignal): Promise<InvoiceCardFeeRecoverySummaryResponse> => {
    const token: string | null = getToken();
    if (!token) {
        throw new Error('Authorization token is not provided');
    }

    const headers: HeadersInit = {
        'Authorization': token,
        'Content-Type': 'application/json',
    };

    const body = JSON.stringify({
        selected_option_id: selectedOptionId,
        selected_add_on_options_ids: selectedAddOnOptionsIds,
        live_key: getLiveKey(),
    })

    const response = await fetch(`${getApiUrl()}/summary/cfr`, {
        method: 'POST',
        signal,
        headers,
        body,
    });

    if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
    }

    return await response.json() as InvoiceCardFeeRecoverySummaryResponse;
};

export const getPublicLinkInvoiceCardFeeRecoverySummaryRequest = async (selectedOptionId: number, selectedAddOnOptionsIds: number[], signal?: AbortSignal): Promise<InvoiceCardFeeRecoverySummaryResponse> => {
    const headers: HeadersInit = {
        'Content-Type': 'application/json',
    };

    const body = JSON.stringify({
        selected_option_id: selectedOptionId,
        selected_add_on_options_ids: selectedAddOnOptionsIds,
    })

    const response = await fetch(`${getApiUrl()}/invoice/summary/cfr`, {
        method: 'POST',
        signal,
        headers,
        body,
    });

    if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
    }

    return await response.json() as InvoiceCardFeeRecoverySummaryResponse;
};